export class OrganizationManagement {
  OrganizationId: number
  OrganizationCode: string
  SaleOrgCode: string
  CompanyCode: string
  DivisionCode: string
  DepartmentCode: string
  SectionCode: string
  UnitCode: string
  RegionCode: string
  BranchCode: string
  SubBranchCode: string
  OrganizationLevel: number
  FlagActive: string
  FlagDelete: string
  CreateDate: string
  CreateBy: string
  UpdateDate: string
  UpdateBy: string
}
